'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThankYou = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThankYou = exports.ThankYou = function ThankYou() {
  return _react2.default.createElement(
    'div',
    { className: 'location-modal--thank-you' },
    _react2.default.createElement(
      'h2',
      { className: 'location-modal__title' },
      _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'thank-you.title',
        defaultMessage: 'Thank you'
      })
    ),
    _react2.default.createElement(
      'p',
      { className: 'location-modal__subtitle' },
      _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'thank-you.subtitle',
        defaultMessage: 'You\u2019ll be the first to know when we\u2019re available in your area.'
      })
    )
  );
};